import {ModelConstructor} from "@shared/models/base.model";
import {CompanyGstReturnItemType, QuarterEnum} from "@generated/graphql";
import {GstReturn} from "@modules/gst-return/models/gst-return.model";
import {gstReturnFactory} from "@modules/gst-return/factories/gst-return.factory";
import {Job} from "@modules/job/models/job.model";
import {jobFactory} from "@modules/job/factories/job.factory";
import {startCase} from "lodash-es";
import {DateTime} from "luxon";
import {parseAnyDate} from "@shared/helpers/date-time.helpers";

export class CompanyGstReturnItem extends ModelConstructor implements CompanyGstReturnItemType {
  canSubmit: boolean;
  canUpload: boolean;
  deadline: Date;
  quarter: QuarterEnum;
  year: number;
  gstReturn?: GstReturn
  job?: Job

  showInitialError(): void {
    throw new Error('Something wrong! when create new ' + CompanyGstReturnItem.name + ' instance');
  }

  constructor(state: CompanyGstReturnItemType) {
    super(state);

    this.gstReturn = gstReturnFactory.tryCreating(state.gstReturn)

    this.job = jobFactory.tryCreating(state.job)

    this.deadline = parseAnyDate(state.deadline)
  }

  get isDeadlinePast () {
    return this.deadline
      ? DateTime.fromJSDate(this.deadline) < DateTime.now()
      : false;
  }

  get quarterAndYear (): string {
    return startCase(this.quarter) + ' - ' + this.year
  }

  get yearAndQuarter (): string {
    return startCase(this.year.toString()) + ' - ' + this.quarter
  }
}
